import { FC, ReactElement, useMemo } from "react";
import { Box, Card, CircularProgress, Stack, styled } from "@mui/material";

import { VendorsTable } from "@/components";
import { columns } from "@/columns/COMMON/programs";
import { PROGRAMS_TOTAL_FIELDS } from "@/constants";
import CardHeading from "../card-heading";

export const StyledBox = styled(Box)({
  flex: 1,
  overflow: "hidden",
  "& .MuiTable-root": {
    borderCollapse: "collapse",

    "& .MuiTableCell-root": {
      border: 0,
    },

    "& .MuiTableBody-root .MuiTableCell-root": {
      padding: "7px 12px !important",
      borderBlock: "1px solid #E6E7E7",
    },

    "& .MuiTableFooter-root .MuiTableCell-root": {
      background: "#CEDBDB",
      fontSize: "18px",
      fontWeight: 500,
      color: "#116B6F",
    },
  },
});

const ProgramsCard: FC<{ data: IProgram[]; isLoading: boolean }> = ({
  data,
  isLoading,
}): ReactElement => {
  const totalSaving = useMemo(() => {
    return data.reduce(
      (prev, { potentialSaving }) => prev + potentialSaving,
      0
    );
  }, [data]);

  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        maxHeight: 432,
      }}
    >
      <Box p={3}>
        <CardHeading text="Agreement Opportunities" />
      </Box>

      {isLoading ? (
        <Stack minHeight={310} justifyContent="center" alignItems="center">
          <CircularProgress />
        </Stack>
      ) : (
        <VendorsTable
          contentIdKey="program"
          columns={columns}
          data={data}
          footerColumns={PROGRAMS_TOTAL_FIELDS}
          footerData={{
            totalSaving,
          }}
          isLoading={false}
          limit={10}
          page={1}
          total={10}
        />
      )}
    </Card>
  );
};

export default ProgramsCard;
